import dayjs from "dayjs";
import "dayjs/locale/cs";
import relativeTime from "dayjs/plugin/relativeTime";
import i18n from "i18next";

dayjs.extend(relativeTime);

export const renderDateSmart = (v?: string | null) => {
    if (!v) return "-";
    const d = dayjs(v);
    if (!d.isValid()) return "-";

    const now = dayjs();
    const dayDiff = now.startOf("day").diff(d.startOf("day"), "day");

    if (dayDiff === 0) {
        return i18n.t("dashboard.table.today", "today");
    }
    if (dayDiff === 1) {
        return i18n.t("dashboard.table.yesterday", "yesterday");
    }
    return d.format("D.M.YYYY");
};

const LOCALE_ALIAS: Record<string, string> = {
    "cs-cz": "cs",
    "en-us": "en",
};

export const syncDayjsLocale = (lang?: string) => {
    if (!lang) {
        dayjs.locale("cs");
        return;
    }
    const normalized = lang.toLowerCase().replace("_", "-");
    const dayjsLocale = LOCALE_ALIAS[normalized] || normalized.split("-")[0] || "cs";
    dayjs.locale(dayjsLocale);
};
